import Cookies from 'universal-cookie';

import { SubmitAppointmentErrorCode } from '@src/constants';
import { postConversionToGoogle } from '@src/utils/post-google-reserve';



const submitAppointment = async ({ consultId, leadId }: { consultId: string; leadId: string }) => {
	try {
		const response = await fetch(process.env.APP_PATH + '/api/clear-choice/submit-appointment/', {
			method: 'PATCH',
			body: JSON.stringify({
				consultId,
				leadId,
			}),
		});

		const data = await response.json();

		if (!response.ok) {
			if (data?.status === SubmitAppointmentErrorCode.CONSULT_SCHEDULED) {
				throw new Error(SubmitAppointmentErrorCode.CONSULT_SCHEDULED);
			} else if (data?.status === SubmitAppointmentErrorCode.NO_APPOINTMENTS) {
				throw new Error(SubmitAppointmentErrorCode.NO_APPOINTMENTS);
			}
			throw new Error(response.statusText);
		}
		// Submit Google Reserve data
		const cookies = new Cookies();
		const fcValue = new URLSearchParams(window.location.search).get('fc') ?? cookies.get('cc-facility-code') ?? '';
		postConversionToGoogle(fcValue);
		return data;
	} catch (error) {
		if (error instanceof Error) {
			throw new Error(`Failed Submitting Appointment`);
		}
		return [];
	}
};

export { submitAppointment };
